/**
 * Filtre la galerie média pour les produits "carte postale" qui partagent
 * plusieurs images (recto/verso) par variante, en s'appuyant sur la
 * convention de nommage déjà en place dans le champ ALT des médias :
 *
 *   A6-recto
 *   A6-verso
 *   A5-recto
 *   A5-verso
 *   A5-cadre-chene          (pas de recto/verso pour cette variante)
 *
 * IMPORTANT — garde-fou produits sans cette convention (ex: affiches avec
 * une seule image par variante) :
 * Le filtre ne s'active QUE si au moins un média a un ALT qui suit le
 * pattern "A<chiffres>(-...)*". Si aucun média ne suit cette convention,
 * le script n'altère RIEN, pour ne jamais impacter les produits qui
 * fonctionnent déjà correctement.
 */
(function () {
  'use strict';

  const SLUG_PATTERN = /^A\d+(-[a-z0-9]+)*$/i;
  const FACE_SUFFIXES = ['recto', 'verso'];

  function stripFaceSuffix(slug) {
    const segments = slug.split('-');
    const last = segments[segments.length - 1].toLowerCase();
    if (FACE_SUFFIXES.includes(last) && segments.length > 1) {
      return segments.slice(0, -1).join('-');
    }
    return slug;
  }

  function getCheckedValue(fragment) {
    const el = document.querySelector(
      'input[name*="' + fragment + '"]:checked, select[name*="' + fragment + '"]'
    );
    if (!el) return '';
    if (el.tagName === 'SELECT') {
      return el.options[el.selectedIndex] ? el.options[el.selectedIndex].value : '';
    }
    return el.value || '';
  }

  function buildSelectedSlug() {
    const format = getCheckedValue('FORMAT') || getCheckedValue('Format');
    const frame = getCheckedValue('Style de cadre') || getCheckedValue('CADRE');

    if (format === 'Carte postale A6') {
      return 'A6';
    }

    if (format === 'Grande carte A5') {
      if (frame && frame.toLowerCase().includes('chêne')) {
        return 'A5-cadre-chene';
      }
      return 'A5';
    }

    return null;
  }

  function galleryUsesCardConvention(gallery) {
    return Array.from(gallery.querySelectorAll('[data-media-alt]')).some((el) => {
      const alt = (el.getAttribute('data-media-alt') || '').trim();
      return SLUG_PATTERN.test(alt);
    });
  }

  function applyFilter(gallery, selectedSlug) {
    gallery.querySelectorAll('[data-media-alt]').forEach((el) => {
      const alt = (el.getAttribute('data-media-alt') || '').trim();

      if (!SLUG_PATTERN.test(alt)) {
        el.removeAttribute('hidden');
        return;
      }

      const mediaSlug = stripFaceSuffix(alt).toLowerCase();
      const visible = mediaSlug === (selectedSlug || '').toLowerCase();
      el.toggleAttribute('hidden', !visible);
    });
  }

  function refreshAllGalleries() {
    const selectedSlug = buildSelectedSlug();

    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (!galleryUsesCardConvention(gallery)) return;
      if (!selectedSlug) return;

      applyFilter(gallery, selectedSlug);
    });
  }

  function updateFrameOptionVisibility() {

    const isA6 = (getCheckedValue('FORMAT') || getCheckedValue('Format')) === 'Carte postale A6';

    const frameInput = document.querySelector('input[value="Cadre bois chêne"]');
    if (!frameInput) return;

    const frameLabel = document.querySelector('label[for="' + frameInput.id + '"]');
    if (!frameLabel) return;

    const frameDisabled = frameInput.classList.contains('disabled') || frameInput.disabled;
    frameLabel.style.display = (isA6 || frameDisabled) ? 'none' : '';

    if (isA6 && frameInput.checked) {
      const noFrameInput = document.querySelector('input[value="Sans cadre"]');
      if (noFrameInput) {
        noFrameInput.click();
      }
    }
  }

  function handleVariantChange() {
    updateFrameOptionVisibility();
    refreshAllGalleries();
  }

  document.addEventListener('DOMContentLoaded', handleVariantChange);

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"], select')) {
      handleVariantChange();
    }
  });

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  }  
  })();